import React, { memo } from 'react';
import { Box } from '@mui/material';
import { TabPanelProps } from './types';

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, keepMounted }) => {
  return (
    <div role='tabpanel' hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`}>
      {keepMounted ? <Box sx={{ pt: 2 }}>{children}</Box> : value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

export default memo(TabPanel);
